import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { LibSharedCommonModule } from '@solvace/common';
import { LibSharedComponentModule } from '@solvace/component';
import { SvcButtonIconModule } from '@solvace/component/svc-btn-icon';
import { SvcAudioToTextButtonComponent } from './svc-audio-to-text-button.component';
import { SvcAudioToTextButtonService } from './svc-audio-to-text-button.service';
import { SvcAudioToTextWrapperComponent } from './wrapper/svc-audio-to-text-wrapper.component';


@NgModule({
  declarations: [
    SvcAudioToTextButtonComponent,
    SvcAudioToTextWrapperComponent,
  ],
  imports: [
    LibSharedCommonModule,
    LibSharedComponentModule,
    TranslocoModule,
    SvcButtonIconModule,
  ],
  providers: [
    SvcAudioToTextButtonService,
  ],
  exports: [
    SvcAudioToTextButtonComponent,
    SvcAudioToTextWrapperComponent,
  ],
})
export class SvcAudioToTextButtonModule { }
